import { common } from '@tencent/ceiba-base-components';
// const Undownload = 0;
const onWaitting = 1;
const onDownloading = 2;
// const Pause = 3;
// const Finish = 4;
// const Fail = 5;
// const Cancel = 6;

function HandleXinYueAppClientDownload() {
  this.gameInfo = {};
  this.remarkKey = '';
  this.getChannel =  () => '10030476';
  this.setGameInfo = (GameInfos) => {
    const {
      game_name: gameName, version,
      gid: gameId, android_pkg_name: androidPkgName, ios_pkg_name: iosPkgName, ios_download_url: iosDownloadUrl,
      android_download_url: androidDownloadUrl, ios_url_scheme: iosUrlScheme, icon, qq_appid: gameQQAppid, apk_md5: md5,
      activityId, channel_no: channelNo,
    } = GameInfos || {};
    const  params = {
      icon,
      packagename: androidPkgName,
      version,
      gamename: gameName,
      iosurl: iosDownloadUrl,
      iosschemeurl: iosUrlScheme,
      url: androidDownloadUrl,
      iOSPkgName: iosPkgName || androidPkgName,
      md5,
      gid: gameId,
      gameAppID: gameQQAppid,
      from: '1015',
      // channelid: '10030476',
      channelid: channelNo,
      activityId,
    };
    if (common.tool.getQueryparams('adreport') !== null) {
      params.from += `*${common.tool.getQueryparams('adreport')}`;
    }
    this.gameInfo = params;
    console.log('-----HandleXinYueAppClientDownload this.gameInfo =----', this.gameInfo);
    return params;
  };
  this.getRemarkKey = gid => `_gameDownLoadStatus_${gid}_process`;
  // 获取已经安装游戏的渠道id
  this.getChannelID = () => {
    if (!window.Tgclub) 0;
    return parseInt(window.Tgclub.getAppChannelInfo(this.gameInfo.packagename, 'channelId'), 10);
  };
  this.doDownloadInIOS = () => window.Tgclub && window.Tgclub.downloadApp(JSON.stringify(this.gameInfo));
  this.startDownload = (callBack) => {
    if (!window.Tgclub) return;
    if  (!this.remarkKey) {
      const that = this;
      this.remarkKey = this.getRemarkKey(this.gameInfo.gid);
      Object.defineProperty(window, this.remarkKey, {
        set: (newValue) => {
          if (typeof callBack === 'function') {
            const { url = '' } = newValue;
            // 多个接收下载 防止污染 客户端的bug
            if (url === that.gameInfo.url) {
              callBack(newValue);
            }
            // 外边进度条
          }
        },
        enumerable: true,
        configurable: true,
      });
    }
    const callbackFunc = `function(ret){if(JSON.parse(ret).totalLen > 0){window.${this.remarkKey} = JSON.parse(ret);}}`;
    console.log('window.Tgclub.downloadApp this.gameInfo = ', this.gameInfo);
    window.Tgclub.downloadApp(JSON.stringify(this.gameInfo), callbackFunc);
  };
  this.checkDownloadState = (callback) => {
    if (!window.Tgclub) return;
    let dataJson =  window.Tgclub.checkDownloadState(this.gameInfo.url);
    dataJson = JSON.parse(dataJson);
    const { state = 0, url } = dataJson;
    // 下载状态初始化 同步app下载的状态  等待中 或开始中 触发开始下载
    //  Waitting === 1  ||  Downloading === 2
    if (state === onWaitting  || state === onDownloading) {
      this.startDownload(callback);
    }
    if (url === this.gameInfo.url && typeof callback === 'function') {
      callback(dataJson);
    }
  };
  this.stopDownloadApp = () => window.Tgclub && window.Tgclub.stopDownloadApp(this.gameInfo.url);
  this.isAppInstalled =  async () =>  window.Tgclub && window.Tgclub.isAppInstalled(this.gameInfo.packagename)
    && (this.getChannelID() ===  10030476 ||   this.getChannelID() ===  10058448);
  this.installGame = () => window.Tgclub && window.Tgclub.installDownloadApp(this.gameInfo.url);
  this.callGame = () => window.Tgclub &&  window.Tgclub.openApp(this.gameInfo.packagename);
  //  是否显示下载 app
  this.isShowDownloadComponent = () => !(window.navigator.userAgent.toLowerCase().indexOf('islegalversion') > -1);
  this.beforeDownloadCheck = () => {
    if (!window.Tgclub) {
      return '';
    }
    const currentVersion = this.getAppVersion();
    console.log('currentVersion =', currentVersion);
    if (!currentVersion) {
      return '';
    }
    if (window.navigator.userAgent.toLowerCase().indexOf('islegalversion') > -1
      && ['6.0.1.51', '6.0.1.52', '6.0.1.53'].some(v => v === currentVersion)) {
      return  '当前版本暂不支持下载，请升级到最新版本后继续下载';
    }
    return  '';
  };
  // 心悦app上报 染色SDK曝光上报
  this.reportGameChanelDownloadViewShow = () => {
    console.log('access reportGameChanelDownloadViewShow', this.gameInfo);
    if (!window.Tgclub) {
      return false;
    }
    if (window.Tgclub && typeof  window.Tgclub.downloadViewShow !== 'function') {
      return false;
    }
    const jsonStr = JSON.stringify(this.gameInfo);
    window.Tgclub.downloadViewShow(jsonStr);
  };
  // 获取app版本
  this.getAppVersion = function () {
    const str = navigator.userAgent.toLowerCase();
    if (!str) {
      return '';
    }
    if (str.match('tgclub') === null) {
      return '';
    }
    const reg = new RegExp('tgclub/([0-9.]+)');
    const res = str.match(reg);
    if (!res || !res[1]) {
      return '';
    }
    if (!res[1] instanceof Array || res[1].length === 0) {
      return '';
    }
    return res[1];
  };
  // 是否uo上报 暂停下载
  this.needReportDownloadPause  = false;
  // 是否uo上报 完成下载
  this.needReportDownloadFinish  = false;
  // 是否uo上报 安装游戏
  this.needReportInstallGame  = false;
  // 是否uo上报  拉起游戏
  this.needReportlaunchGame  = false;
  console.log('-----------------------------init done HandleXinYueAppClientDownload');
  return this;
};

export default HandleXinYueAppClientDownload;
export { HandleXinYueAppClientDownload };
